import {
  getFileDocumentKind,
  guessFileNameFromUrl,
  type MessageAttachment,
} from '@teo/widget-shared';
import { useWidget } from '../context/WidgetContext.js';
import { IconDownload } from '../components/icons.js';
import { FileTypeIcon } from './FileTypeIcon.js';

type FileAttachmentProps = {
  attachment: MessageAttachment;
};

export function FileAttachment({ attachment }: FileAttachmentProps) {
  const { t } = useWidget();
  const fileName =
    attachment.fileName ?? guessFileNameFromUrl(attachment.url);
  const docKind = getFileDocumentKind(fileName, attachment.mimeType);

  return (
    <a
      className="teo-rich-media__file"
      href={attachment.url}
      download={fileName}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FileTypeIcon kind={docKind} />
      <span className="teo-rich-media__file-info">
        <span className="teo-rich-media__file-name">{fileName}</span>
        <span className="teo-rich-media__file-action">{t.mediaDownload}</span>
      </span>
      <IconDownload size={16} className="teo-rich-media__file-download" />
    </a>
  );
}
